{
  "common": {
    "operandValue": "值 {{value}}"
  }
}
